import React, { Component } from 'react';

import * as Func from '../../../../helpers/functions';
import { PRICE_MAKEUP, TRANSLATE_LANGUAGE } from '../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent,
    LoadingComponent,
} from "../../common/component/Index";
import Input from "../../common/component/Input";
import TextArea from "../../common/component/TextArea";
import RichTextEditor from "../../common/component/RichTextEditor";
import Wrapper from "../../common/component/Wrapper";
import Modal from "../../common/component/Modal";
import Span from '../../common/component/Span';
import Form from '../../common/component/Form';
import Radio, { RadioButton, RadioGroup } from '../../common/component/Radio';

import { Icon } from 'antd';
import { find, findIndex, toArray, merge, isEqual } from 'lodash';

import './TranslateDetail.less';
import Images from '../../../../constants/Images';

const InputControl = { Input, Radio, TextArea, RichTextEditor, }

export default class TranslateDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            validation: {},
            currentLanguage: this.props.language,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(this.props.data, prevProps.data)) {
            this.setState({ data: this.props.data })
        }
    }

    render() {
        const { t, title, visible, width, loading, language } = this.props;
        return (
            <Modal
                width={width}
                bodyStyle={{ padding: 0 }}
                title={<Span>
                    {title || t(`action.translate`)}:
                    <img src={Images.flag.square[language]} alt={t(`translate.languages.${language}`)} className="flag-icon-16px mr-1 ml-2" />
                    {t(`translate.languages.${language}`)}
                </Span>}
                visible={visible}
                onOk={this.onSave} okText={t(`action.save`)}
                confirmLoading={loading}
                onCancel={this.onCancel} cancelText={t(`action.cancel`)}
            >
                {this.renderInputs()}
            </Modal>
        );
    }

    renderInputs() {
        const { t, inputs } = this.props;
        const { data, validation } = this.state
        return (
            <Wrapper className="translate-detail-inputs">
                <Form onSubmit={this.onSubmit}>
                    <FormWrapperItem>
                        {inputs.map(input => (
                            <Wrapper key={input.name} className={input.className}>
                                <FormWrapperInputComponent
                                    {...(input.wrapperProps || {})}
                                    dataValidation={data[input.name]}
                                    validation={validation[input.name]}
                                    labelTitle={t(`item.${input.itemType}.${input.name}`)}
                                >
                                    {this.renderInputControl(input)}
                                </FormWrapperInputComponent>
                            </Wrapper>
                        ))}

                    </FormWrapperItem>
                </Form>
            </Wrapper>
        )
    }

    renderInputControl(input) {
        const { data } = this.state;
        const { loading } = this.props;
        switch (input.control) {
            case InputControl.Input:
                return (
                    <Input placeholder={input.placeholder} type={input.type}
                        className={`form-control`} disabled={loading}
                        name={input.name} onChange={(e) => this.onChange(input.name, e.target.value)}
                        value={Func.checkUndefine(data[input.name])} />
                )
            default:
                return null;
        }
    }

    onSave = () => {
        const { languages, language } = this.props;
        if (this.validate()) {
            const lang = find(toArray(TRANSLATE_LANGUAGE), item => item.id === language);
            if (lang) {
                lang.included = findIndex(languages || [], item => item.code.split('-')[0] === lang.id) !== -1
                return this.props.onSave(this.state.data, lang);
            }
        }
    }

    onSubmit = (e) => {
        this.onSave()
    }

    onCancel = () => {
        this.setState({ validation: Func.multipleValidate({}, undefined, undefined) });
        this.props.onCancel();
    }

    onChange = (fieldName, value) => {
        const data = this.state.data;
        data[fieldName] = value;
        this.setState({ data })
    }

    validate() {
        const { inputs } = this.props;
        let validate = {};
        let valueValidate = {};
        inputs.forEach(input => {
            if (input.validate) {
                validate = merge(validate, input.validate);
                valueValidate = merge(valueValidate, input.valueValidate);
            }
        });
        const result = Func.multipleValidate(this.state.data, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

}

TranslateDetail.defaultProps = {
    visible: false,
    title: '',
    loading: false,
    language: undefined,
    width: undefined,
    inputs: [],
    onSave: (data, lang) => { },
    onRemove: lang => {},
    onCancel: () => { },
}
